import { render, staticRenderFns } from "./WillTenantsInCommonYN.vue?vue&type=template&id=3e148704"
import script from "./WillTenantsInCommonYN.vue?vue&type=script&lang=js"
export * from "./WillTenantsInCommonYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports